<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <el-form-item 
            :class="className"
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <input :name="fieldName" :value="valueString" hidden="hidden">
            <el-select-v2 
                :options="userOptions"
                multiple 
                class="qweelement"
                v-model="data[name]" 
                filterable 
                :disabled = "disabled"
                placeholder="请选择">
            </el-select-v2>
            <div class="hint"><i>{{ hint }}</i></div>
        </el-form-item>
    </el-col>
</template>

<script>
    import baseUserField from "./BaseUserField"
    import { CirclePlus } from '@element-plus/icons-vue'

    export default {
        name:"UserField",
        mixins:[baseUserField],
        components:{
            "circle-plus":CirclePlus
        }
    }
</script>